import { Injectable } from '@angular/core';

export interface IAudioPlayerService {
	playAsset(asset: string): void;
	play(audio: HTMLAudioElement): void;
	stop(): void;
}

@Injectable({
	providedIn: 'root'
})
export class AudioPlayerService {

	private current: HTMLAudioElement | undefined = undefined;

	constructor() { }

	playAsset(asset: string): void {
		const audio = new Audio(asset);
		this.play(audio);
	}

	play(sound: HTMLAudioElement): void {
		this.stop();

		this.current = sound;
		this.current.play().catch(error => console.error(error));
	}

	stop(): void {
		if (this.current) {
			this.current.pause();
			this.current.currentTime = 0;
			this.current = undefined;
		}
	}
}
